import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  Grid, Paper, Table, TableHead, Tooltip, Typography,
  TableRow, TableCell, TableBody, TableContainer
} from '@material-ui/core'

import AnnouncementIcon from '@material-ui/icons/Announcement'

import { withStyles } from '@material-ui/core/styles'

import { getWebsitesReport, setFromLink } from '../../../redux/actions'
import { setFilter, setReportsModal } from '../../../redux/actions/select'

import { defaultFilter } from '../../../utils/variables'

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'rgba(0, 0, 0, 0.54)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    leavTouchDelay: 10000
  }
}))(Tooltip)

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow)

/**
 * Returns websites report
 */
const WebsitesReport = (props) => {
  const { classes, page, rowsPerPage, websitesReport, fromLink } = props

  const dispatch = useDispatch()

  const View = useSelector(state => state.userSettings.general.defaultView)
  const Filter = useSelector(state => state.selection.Filter)

  // const [page, setPage] = useState(0)
  // const [rowsPerPage, setRowsPerPage] = useState(25)

  useEffect(() => {
    (async () => {
      await dispatch(getWebsitesReport(Filter))
        .catch((err) => {
          console.error(err)
        })
    }
    )()
  }, [dispatch, Filter])

  const handleWebsiteFilter = (website) => {
    const filter = { ...defaultFilter, websiteUrl: website.key }
    dispatch(setFilter(filter))
    if (fromLink) {
      dispatch(setFromLink(false))
    }
    dispatch(setReportsModal(false))
    if (View === 'L') {
      props.history.push({
        pathname: '/captures',
        search: '?view=list&page=1&activeCapture=0'
      })
    } else if (View === 'G') {
      props.history.push({
        pathname: '/captures',
        search: '?view=grid&page=1&activeCaptures=[]'
      })
    } else {
      props.history.push({
        pathname: '/captures',
        search: '?view=single&capture=1'
      })
    }
  }

  const truncateText = (str, length = 30) => {
    return str.length > 30 ? str.substring(0, length) + '...' : str
  }

  return (
    <>
      <Grid container direction='column' justify='center' style={{ minWidth: '650px' }}>
        <Grid container direction='row'>
          <Grid container item direction='column' justify='flex-end' xs={12} className={classes.tableContainer}>
            <Paper elevation={2} className={classes.tablePaper}>
              <Grid
                container
                direction='column'
                justify='center'
                className='px-3 w-100 py-3 mx-auto my-auto'
                spacing={2}
              >
                {
                  websitesReport.length > 0
                    ? (
                      <>
                        <TableContainer>
                          <Table className={classes.table} size='small' aria-label='users-table'>
                            <TableHead>
                              <TableRow>
                                <TableCell className={`${classes.tableHeadText} unselectable`}>Websites</TableCell>
                                <TableCell className={`${classes.tableHeadText} unselectable`} align='right'>Captures</TableCell>
                                <TableCell className={`${classes.tableHeadText} unselectable`} align='right'>Total Severity</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {websitesReport.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((website, index) => (
                                <StyledTableRow key={index}>
                                  <TableCell
                                    className={classes.tableText}
                                    component='th'
                                    scope='row'
                                    style={{ cursor: 'pointer' }}
                                    onClick={(e) => { e.preventDefault(); handleWebsiteFilter(website) }}
                                  >
                                    {
                                      website.key.length > 30
                                        ? (
                                          <LightTooltip title={website.key} placement='top-end' arrow>
                                            <Typography className={classes.tableText}>{truncateText(website.key)}</Typography>
                                          </LightTooltip>

                                        )
                                        : (
                                          <Typography className={classes.tableText}>{website.key}</Typography>
                                        )
                                    }
                                  </TableCell>
                                  <TableCell className={`${classes.tableText} unselectable`} align='right'>{website.doc_count}</TableCell>
                                  <TableCell className={`${classes.tableText} unselectable`} align='right'>{website.total_severity.value}</TableCell>
                                </StyledTableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    )
                    : (
                      <>
                        <Grid item container direction='row' justify='center' alignItems='center'>
                          {/* <Loader type='ThreeDots' color='#97b557' height={150} width={150} /> */}
                          <Paper
                            className='mx-auto'
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginTop: '10vh',
                              height: '20rem',
                              width: '30rem',
                              backgroundColor: '#F5F5F5'
                            }}
                          >
                            <Grid item container direction='column' xs={12}>
                              <Grid item container direction='row' justify='center'>
                                <AnnouncementIcon
                                  style={{
                                    fontSize: '4rem',
                                    color: 'grey',
                                    marginBottom: '1rem'
                                  }}
                                />
                              </Grid>
                              <Grid item container direction='row' justify='center'>
                                <Typography
                                  style={{ fontWeight: 'bold', color: 'grey', fontSize: '1.5rem' }}
                                >
                                  No Report Found
                                </Typography>
                              </Grid>
                              <Grid item container direction='row' justify='center'>
                                <Typography>Please try changing your selection in 'My Schools'</Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </>
                    )
                }
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default withRouter(WebsitesReport)
